module.exports = __webpack_public_path__ + "static/img/n-wasm-check.c896b536.png";